import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import config from "react-global-configuration"
import * as path from "../constants/Paths"

class NotFound extends Component {
  render() {
    this.props.genericModalOpen(
      config.get("textKeys.dialog.NotFoundSearchNewParking") || "<h3>Siden kunne ikke findes</h3><p>Søg efter en ny parkering</p>",
    )
    return <Redirect to={path.HOME()} />
  }
}

export default NotFound
